// extracted by mini-css-extract-plugin
module.exports = {"header":"_5dad9a3","body":"_36db227","text":"_68405fd"};